(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /*
   * StickyHeader - self-contained scroll-up reveal.
   *
   * Modes (data-sticky-type):
   *   on-scroll-up      header scrolls away normally, slides back in on any
   *                     upward scroll, slides out again on downward scroll
   *   always            header pins to the top once it would scroll off
   *   reduce-logo-size  same as "always" + .scrolled-past-header for the CSS
   *
   * Mechanism: once the section has scrolled fully out of view it is switched
   * to position: fixed and a spacer of identical height takes its place in the
   * document flow, so nothing below it moves. Visibility is then purely a
   * transform on the section.
   *
   * Two things keep it glitch-free around whatever sits above the header
   * (announcement bar, marquee):
   *   1. The header's natural slot is re-measured on every scroll tick, so a
   *      marquee that finishes rendering after load can't leave a stale value.
   *   2. When the header is handed back to the document flow it starts from
   *      where it was on screen and slides the last few pixels into its slot,
   *      instead of snapping by however far the last scroll frame moved.
   */
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.shopify-section') || this.parentElement;
      this.stickyType = this.getAttribute('data-sticky-type') || 'on-scroll-up';
      this.alwaysVisible = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.predictiveSearch = this.querySelector('predictive-search');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.isFixed = false;
      this.isHidden = false;
      this.settling = false;
      this.preventReveal = false;
      this.ticking = false;
      this.lastHeaderHeight = null;
      this.lastScrollTop = this.getScrollTop();

      this.spacer = document.createElement('div');
      this.spacer.className = 'hdr-fixed-spacer';
      this.spacer.setAttribute('aria-hidden', 'true');
      this.header.insertAdjacentElement('afterend', this.spacer);

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onScrollHandler, { passive: true });
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.measure(this.lastScrollTop);
      this.update(this.lastScrollTop, 0);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onScrollHandler);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.clearTimeout(this.settleTimer);
      this.release(this.getScrollTop(), false);
      this.clearSettle();
      if (this.spacer) this.spacer.remove();
    }

    getScrollTop() {
      return Math.max(
        0,
        window.scrollY || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      );
    }

    // Where the header naturally lives in the document, measured live. While
    // fixed, the spacer occupies that slot, so measure the spacer instead.
    // Skipped during the settle animation because the transform would skew it.
    measure(scrollTop) {
      if (this.settling) return;
      // The slot only matters near the top of the page; skip the layout read
      // when scrolled well below it (the value is refreshed on the way back up).
      if (this.headerBottom !== undefined && scrollTop > this.headerBottom + window.innerHeight * 2) return;
      const anchor = this.isFixed ? this.spacer : this.header;
      const top = anchor.getBoundingClientRect().top + scrollTop;
      const height = this.header.offsetHeight;

      this.headerTop = top;
      this.headerHeight = height;
      this.headerBottom = top + height;

      if (height !== this.lastHeaderHeight) {
        this.lastHeaderHeight = height;
        if (this.isFixed) this.spacer.style.height = `${height}px`;
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      }
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        const scrollTop = this.getScrollTop();
        const delta = scrollTop - this.lastScrollTop;
        this.lastScrollTop = scrollTop;
        this.measure(scrollTop);
        this.update(scrollTop, delta);
      });
    }

    update(scrollTop, delta) {
      // Leave the header alone while one of its own overlays is open
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (this.header.classList.contains('menu-open')) return;

      // Back at (or above) the header's natural slot: hand it back to the flow
      if (scrollTop <= this.headerTop) {
        this.header.classList.remove('scrolled-past-header');
        this.release(scrollTop, true);
        return;
      }

      if (this.alwaysVisible) {
        this.header.classList.toggle('scrolled-past-header', scrollTop > this.headerBottom);
        this.fix(false);
        return;
      }

      // Header is partially on screen in its natural slot; let it scroll naturally.
      // If we arrive here already fixed (coming back up), make sure it's showing.
      if (scrollTop <= this.headerBottom) {
        if (this.isFixed && delta < 0) this.reveal();
        return;
      }

      this.header.classList.add('scrolled-past-header');

      // First time past the bottom edge: header is already off screen, so
      // pin it hidden with no transition. Visually nothing changes.
      if (!this.isFixed) {
        this.fix(true);
        return;
      }

      if (delta > 0) {
        // Dawn's header-menu sets preventHide on this element while a dropdown is open
        if (this.preventHide) return;
        this.hide();
      } else if (delta < 0) {
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          this.hide();
        }
      }
    }

    fix(hidden) {
      if (!this.isFixed) {
        this.clearSettle(); // never carry an in-flight settle transform into the fixed state
        this.spacer.style.height = `${this.headerHeight}px`;
        this.spacer.style.display = 'block';
        this.header.classList.remove('hdr-animate');
        this.header.classList.add('hdr-is-fixed');
        this.isFixed = true;
      }
      if (hidden) this.hide();
    }

    release(scrollTop, animate) {
      if (!this.isFixed) return;
      const wasVisible = !this.isHidden;
      // How far below the viewport top the header's slot is at this instant.
      const offset = Math.max(0, Math.round(this.headerTop - scrollTop));

      this.header.classList.remove('hdr-is-fixed', 'hdr-is-hidden', 'hdr-animate');
      this.spacer.style.display = 'none';
      this.isFixed = false;
      this.isHidden = false;

      if (animate && wasVisible && offset > 0 && !this.reduceMotion.matches) {
        this.settle(offset);
      }
    }

    // The header was pinned at the viewport top; its slot is `offset`px lower.
    // Start it where it was and glide into place, so there is no visible snap.
    settle(offset) {
      window.clearTimeout(this.settleTimer);
      const el = this.header;
      this.settling = true;
      el.style.transition = 'none';
      el.style.transform = `translateY(-${offset}px)`;
      void el.offsetWidth; // flush, so the transition starts from the translated position
      el.style.transition = 'transform 0.15s ease-out';
      el.style.transform = 'translateY(0)';
      this.settleTimer = setTimeout(() => this.clearSettle(), 180);
    }

    clearSettle() {
      window.clearTimeout(this.settleTimer);
      this.header.style.transition = '';
      this.header.style.transform = '';
      this.settling = false;
    }

    hide() {
      if (!this.isFixed || this.isHidden) return;
      this.header.classList.add('hdr-is-hidden');
      this.isHidden = true;
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this.isFixed || !this.isHidden) return;
      this.header.classList.add('hdr-animate');
      this.header.classList.remove('hdr-is-hidden');
      this.isHidden = false;
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') disclosure.close();
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
